import {
  BookOpen,
  ClipboardList,
  Home,
  LockKeyhole,
  Search,
} from "lucide-react";

import massFlag from "./Flag_of_Massachusetts.svg";
import heroImage from "./53691941021_32452563b0_k-1536x1023.jpg";
import communityImage from "./53692293039_82e4b561e9_o-1536x1140.jpg";
import cambridgeImage from "./Things-to-Do-in-Cambridge-Massachusetts-scaled.jpg";
import bostonImage from "./downtown-cityscape-boston-massachusetts.avif";

const navItems = [
  { href: "/", label: "Home", icon: Home },
  { href: "/start", label: "Start Here", icon: Search },
  { href: "/complaint", label: "Prepare Complaint", icon: ClipboardList },
  { href: "/resources", label: "Resources", icon: BookOpen },
  { href: "/admin", label: "Staff", icon: LockKeyhole },
];

const siteImages = [
  { src: heroImage, alt: "Cambridge community view", label: "Community" },
  { src: communityImage, alt: "Massachusetts community setting", label: "Support" },
  { src: massFlag, alt: "Massachusetts flag", label: "Massachusetts" },
  { src: cambridgeImage, alt: "Cambridge Massachusetts street view", label: "Cambridge" },
  { src: bostonImage, alt: "Boston Massachusetts cityscape", label: "Greater Boston" },
];

export default function Layout({ path, navigate, children }) {
  const goTo = (event, href) => {
    event.preventDefault();
    navigate(href);
  };

  return (
    <div className="min-h-screen bg-slate-50 text-civic-navy">
      <header className="border-b border-civic-line bg-white">
        <div className="mx-auto flex max-w-7xl flex-col gap-4 px-4 py-4 sm:px-6 lg:flex-row lg:items-center lg:justify-between lg:px-8">
          <a
            href="/"
            onClick={(event) => goTo(event, "/")}
            className="focus-ring flex items-center gap-3 rounded-md"
          >
            <div className="relative flex h-14 w-14 shrink-0 items-center justify-center overflow-hidden rounded-md bg-civic-navy shadow-sm ring-1 ring-civic-line">
              <img
                src={heroImage}
                alt=""
                aria-hidden="true"
                className="absolute inset-0 h-full w-full object-cover opacity-75"
              />
              <div className="absolute inset-0 bg-civic-navy/45" />
              <span className="relative text-sm font-black tracking-wide text-white">
                CCS
              </span>
            </div>

            <div>
              <div className="text-lg font-black text-civic-navy sm:text-xl">
                Cambridge Consumer Solutions
              </div>
              <div className="text-sm text-slate-500">
                Consumer assistance and complaint preparation
              </div>
            </div>
          </a>

          <nav className="flex flex-wrap gap-2">
            {navItems.map(({ href, label, icon: Icon }) => {
              const active = path === href;

              return (
                <a
                  key={href}
                  href={href}
                  onClick={(event) => goTo(event, href)}
                  className={`focus-ring inline-flex min-h-11 items-center gap-2 rounded-md px-3 py-2 text-sm font-bold transition ${
                    active
                      ? "bg-civic-sky text-civic-blue ring-2 ring-civic-blue"
                      : "text-slate-700 hover:bg-slate-100 hover:text-civic-navy"
                  }`}
                >
                  <Icon className="h-4 w-4" aria-hidden="true" />
                  {label}
                </a>
              );
            })}
          </nav>
        </div>

        <div className="border-t border-civic-line bg-slate-50">
          <div className="mx-auto grid max-w-7xl grid-cols-2 gap-3 px-4 py-4 sm:grid-cols-3 sm:px-6 lg:grid-cols-5 lg:px-8">
            {siteImages.map((image) => (
              <div
                key={image.label}
                className="group overflow-hidden rounded-md border border-civic-line bg-white shadow-sm"
              >
                <img
                  src={image.src}
                  alt={image.alt}
                  className="h-28 w-full object-cover transition duration-300 group-hover:scale-105"
                />
                <div className="border-t border-civic-line px-3 py-2 text-xs font-bold text-slate-600">
                  {image.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </header>

      <main>{children}</main>

      <footer className="border-t border-civic-line bg-white">
        <div className="mx-auto grid max-w-7xl gap-8 px-4 py-10 sm:px-6 md:grid-cols-2 lg:px-8">
          <div>
            <div className="text-lg font-black text-civic-navy">
              Cambridge Consumer Solutions
            </div>

            <p className="mt-4 text-sm leading-6 text-slate-600">
              This portal helps consumers organize disputes, prepare written
              complaint information, and locate consumer protection resources.
              It does not provide legal advice and does not replace official
              filing requirements, deadlines, or agency review.
            </p>

            <p className="mt-4 text-xs leading-5 text-slate-500">
              Website created by Degefe McCracken-Bradley.
            </p>
          </div>

          <div>
            <div className="text-sm font-black text-civic-navy">Portal</div>

            <div className="mt-4 grid gap-3 text-sm font-bold">
              <a
                href="/start"
                onClick={(event) => goTo(event, "/start")}
                className="text-civic-blue hover:text-blue-900"
              >
                Start a guided review
              </a>

              <a
                href="/complaint"
                onClick={(event) => goTo(event, "/complaint")}
                className="text-civic-blue hover:text-blue-900"
              >
                Prepare a complaint
              </a>

              <a
                href="/resources"
                onClick={(event) => goTo(event, "/resources")}
                className="text-civic-blue hover:text-blue-900"
              >
                View resources
              </a>
            </div>
          </div>
        </div>
      </footer>

    </div>
  );
}
